import Vue from 'vue'
import axios from 'axios'
const baseUrl = `/wp-json/wp/v2`
import accordion from '../components/accordionParent.vue'

if (document.getElementById('vue-faqs')) {
  new Vue({
    delimiters: ["[[", "]]"],
    async asyncData({ params, $http }) {
      const faqs = await $http.$get(`${baseUrl}/faq`)
      return { faqs }
    },
    el: '#vue-faqs',
    components: {
        accordion
    },    
    data() {
      return {
        isLoading: true,
        categories: [],
        filters: {
          page: 1,
          per_page: 100,
        },
        faqs: [],
        totalPages: null
      }
    },    
    mounted() {
      this.getCategories()
      this.getFaqs()
    },
    methods: {
      scrollTo(value){
        this.updateCategory(value.id)
        let headerHeight = document.getElementById('vue-header').clientHeight;
        let anchorsBarHeight = document.getElementById('anchors-bar').clientHeight;
        let domRect = document.getElementById(value.slug).offsetTop;        
        window.scroll({
            top: domRect - (anchorsBarHeight + headerHeight ),
            left: 0,
            behavior: "smooth"
        });
      },
      scrollToTop() {
        this.updateCategory()
        window.scrollTo(0,0);
      },
      getCategories() {
        axios.request({
          method: 'GET',
          url: `${baseUrl}/categories_faq`,
          params: {
            per_page: 100,
          }
        }).then(response => {
          this.categories = response.data
          this.deleteEmptyCategories()
        })
      },
      deleteEmptyCategories() {
        this.categories = this.categories.filter((el) => el.count != 0)
      },
      getFaqs(more = false) {
        this.isLoading = true
        axios.request({
          method: 'GET',
          url: `${baseUrl}/faq`,
          data: this.form,
          headers: { 'content-type': 'application/json' },
          params: this.filters
        }).then(response => {
          this.faqs = (more)? this.faqs.concat(response.data) : response.data
          this.totalPages = response.headers['x-wp-total']
          this.isLoading = false
        }).catch((error) => {
          this.errors = Object.assign(this.errors, error.response.data)
        })
      },
      getCategory(category_id) {
        let category = this.categories.filter((obj) => obj.id === category_id)
        let categoryName = (category.length > 0)? category[0]['name'] : ''
        return categoryName
      },
      updateCategory(category) {
        Vue.set(this.$data.filters, "categories_faq", category);
      },
      
    }
  })
}
